export default {
    "fr": {
        "Answer": "Répondre",
        "Answer to this comment": "Répondre à ce commentaire",
        "Leave a comment": "Laisser un commentaire",
        "You are currently logged as": "Vous êtes actuellement connecté en tant que",
        "Comments": "Commentaires",
        "Empty comments": "Aucun commentaire pour le moment.",
        "Comments are closed": "Les commentaires sont fermés.",
        "Send": "Envoyer"
    },
    "en": {
        "Answer": "Answer",
        "Answer to this comment": "Answer to this comment",
        "Leave a comment": "Leave a comment",
        "You are currently logged as": "You are currently logged as",
        "Comments": "Comments",
        "Empty comments": "Empty comments",
        "Comments are closed": "Comments are closed",
        "Send": "Send"
    }
}
